import { axiosPrivate } from "../api/axios";

// The private API client. Its interceptors (token, refresh, errors) are registered once by
// components/ApiInterceptors, mounted in index.js.
const useAxiosPrivate = () => axiosPrivate;

export default useAxiosPrivate;
